// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcastBadge-cls1_75g","cls2":"RecommendedPodcastBadge-cls2_LSh RecommendedPodcastBadge-cls1_75g"};